<template lang="pug">
    div.modal-bg(@click="closeModal")
        div.upgrade-upper-master-modal(@click.stop)
            div
                p.mb-0 プランをアップグレードしますか？
                span#modal-close(@click="closeModal")
            div
                p.mb-2 選択した機能はEnterpriseプランもしくはCustomプランでご利用可能です。
                a(href="/users/plans") プラン変更はこちら
    </template>

    <script>
    export default {
        methods: {
            closeModal() {
                this.$emit('close-modal'); // 親コンポーネントへイベントを通知
            },
        },
    }
    </script>
</template>
